import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusSolidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 19.4 19.5",
	style: { enableBackground: "new 0 0 19.4 19.5" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.plus-solid-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "plus-solid-icon-st0",
		d: "M9.7,0C7.8,0,5.9,0.6,4.3,1.6S1.4,4.2,0.7,6s-0.9,3.7-0.6,5.6c0.4,1.9,1.3,3.6,2.7,5s3.1,2.3,5,2.7 c1.9,0.4,3.9,0.2,5.6-0.6c1.8-0.7,3.3-2,4.4-3.6s1.6-3.5,1.6-5.4c0-2.6-1-5.1-2.9-6.9C14.8,1,12.3,0,9.7,0z M13.5,10.5h-3v3 c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2S9.4,14.1,9.3,14s-0.2-0.3-0.2-0.5v-3h-3c-0.2,0-0.4-0.1-0.5-0.2 C5.5,10.2,5.4,10,5.4,9.8s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h3v-3c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2 s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v3h3c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5s-0.1,0.4-0.2,0.5 C13.8,10.4,13.6,10.5,13.5,10.5z"
	}) }) }) })]
});
export default SvgPlusSolidIcon;
